export default "/images/82a0d9a7b2d7ef9914718c05cf260bf3.png";